/* ============================================================
   SchedulerRecentPosts — TASK-319. Posting (Scheduler) plan's dashboard
   activity feed: the last up-to-5 content items from
   useContentFeedContext().content, already mapped (title/date/platforms)
   by ContentFeedContext's mapContentRow. Row click opens the post; a
   header link opens the full Library. No status pill, no metrics —
   surfacing failures is AttentionPanel's job, not this card's.
   ============================================================ */
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icons as I } from '../pack-icons';
import { BrandIcons } from '../pack-icons/brands';

export default function SchedulerRecentPosts({ items = [] }) {
  const { t } = useTranslation();
  if (!items?.length) return null;
  return (
    <section className="card attn-panel">
      <div className="attn-head">
        <div>
          <div className="eyebrow"><span>{t('schedulerDash.recentEyebrow')}</span></div>
          <h3>{t('schedulerDash.recentTitle')}</h3>
        </div>
        <Link to="/app/library" className="week-link">
          {t('schedulerDash.recentLink')} <I.arrowRight size={12} />
        </Link>
      </div>
      <div className="attn-list">
        {items.map((item) => (
          <Link key={item.id} to={`/app/post/${encodeURIComponent(item.id)}`} className="attn-item">
            <span className="attn-ico attn-ico-neutral">{BrandIcons[item.platforms?.[0]]?.({ size: 14 })}</span>
            <div className="attn-text">
              <div className="attn-title attn-title-clip">{item.title}</div>
              <div className="attn-sub">{item.date}</div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
